<template>
  <div style="margin:1%">
     <b-row align-v="end" align-h="start">
      <b-col cols="2">
        <md-button v-if="currentRow" @click.stop="showAddAccount" class="md-raised">{{ $t('Add') }}</md-button>
      </b-col>
    </b-row>
    <b-table striped hover small fixed
    :items="accountList"
    :fields="fields"
    @row-clicked="rowClickHandler"
    :per-page="perPage"
    :current-page="currentPage"
    selectable
    @row-selected="onRowSelected"
    select-mode="single">
      <template v-slot:cell(actions)="row">
        <i v-if="isShowPayment" @click.stop="ClickOnPaymentButton(row)" class="info fa fa-money-bill fa-lg"/>
        <i @click.stop="ClickOnDeleteAccountsButton(row)" class="danger fa fa-trash-alt fa-lg"/>
      </template>
      <template slot="row-details" slot-scope="row">
        <div style="margin:1px">
          <Detail ref="Detail"
           :currentRow="row.item"
            @makeToasts="makeToasts"
            @refreshTable="refreshTable"/>
        </div>
      </template>
    </b-table>

    <b-modal ref="modalAddAccount" hide-footer @hidden="isShowAddAccount = false" @show="isShowAddAccount = true" :title="$t('New account')">
      <FormAddAccount @refreshTable="refreshTable" @hideAddAccount="hideAddAccount" @makeToasts="makeToasts" :currentRow="currentRow"/>
    </b-modal>
  </div>
</template>

<script>
import Detail from '@/pages/users/accounts/detail/main'
import FormAddAccount from '@/pages/users/accounts/formAdd'
export default {
  components: {
    Detail,
    FormAddAccount
  },
  props: {
    filter: null,
    userId: null,
    isShowPayment: null,
    perPage: null,
    currentPage: null,
    currentRow: null
  },
  data () {
    return {
      accountId: null,
      isShowAddAccount: false,
      userList: [],
      fields: [
        { key: 'account_id', label: this.$i18n.t('ID accounts'), sortable: true, sortDirection: 'desc' },
        { key: 'login', label: this.$i18n.t('Customer'), sortable: true, sortDirection: 'desc' },
        { key: 'balance', label: this.$i18n.t('Balance'), sortable: true, sortDirection: 'desc' },
        { key: 'freezed_balance', label: this.$i18n.t('Freezed'), sortable: true, sortDirection: 'desc' },
        { key: 'credit', label: this.$i18n.t('Credit'), sortable: true },
        { key: 'active_block_name', label: this.$i18n.t('Block inet'), sortable: true },
        { key: 'groupsStr', label: this.$i18n.t('Groups'), sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      totalRows: 0
    }
  },
  methods: {
    load () {
      if (this.userId) {
        this.$store.dispatch('Users/GET_ACCOUNT_USER', this.userId)
      } else if (!this.currentRow) {
        let curFilter = ''
        if (this.filter) {
          curFilter = this.filter
        }
        this.$store.dispatch('Users/CREATE_ACCOUNT_SEARCH', { 'value': curFilter })
      } else {
        this.$store.dispatch('Users/GET_ACCOUNT_USER', this.currentRow.user_id)
      }
    },
    ClickOnDeleteAccountsButton (row) {
      this.accountId = row.item
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Accounts"?'), this.deleteAccounts, row.item)
    },
    deleteAccounts () {
      let response = this.$store.dispatch('Users/DELETE_ACCOUNT', this.accountId.account_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          if (!this.currentRow) {
            let curFilter = ''
            if (this.filter) {
              curFilter = this.filter
            }
            this.$store.dispatch('Users/CREATE_ACCOUNT_SEARCH', { 'value': curFilter })
          } else {
            this.$store.dispatch('Users/GET_ACCOUNT_USER', this.currentRow.user_id)
          }
          this.$root.$emit('makeToasts')
        }
      })
    },
    showAddAccount () {
      this.isShowAddAccount = true
      this.$refs.modalAddAccount.show()
    },
    hideAddAccount () {
      this.isShowAddAccount = false
      this.$refs.modalAddAccount.hide()
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    refreshTable () {
      this.load()
      this.$emit('refreshTable')
    },
    onRowSelected (items) {
      for (let i in this.selected) {
        for (let j in items) {
          if (this.selected[i] === items[j]) {
            break
          }
        }
        this.selected[i]._showDetails = false
      }
      this.selected = items
      for (let i in this.selected) {
        this.selected[i]._showDetails = true
      }
    },
    rowClickHandler (record, index) {
      this.$emit('clickOnAccount', record)
    },
    ClickOnPaymentButton (row) {
      this.$emit('ClickOnPaymentButton', row.item)
    }
  },
  computed: {
    accountList () {
      let tmp = []
      if (!this.currentRow && !this.userId) {
        for (let el of this.$store.getters['Users/ACCOUNT_SEARCH']) {
          let curAccount = el
          if (curAccount.active_block_id) {
            curAccount.active_block_name = 'Block'
            curAccount._cellVariants = {active_block_name: 'danger'}
          } else {
            curAccount.active_block_name = 'Active'
          }
          curAccount.balance = Number.parseFloat(curAccount.balance).toFixed(2)

          curAccount.groupsStr = ''
          for (let elGroup of this.allAccInGroups) {
            if (elGroup.account_id === curAccount.account_id) {
              curAccount.groupsStr += curAccount.groupsStr.length ? ',' : ''
              curAccount.groupsStr += elGroup.group_name + '(' + elGroup.group_id + ')'
            }
          }
        }
        tmp = this.$store.getters['Users/ACCOUNT_SEARCH']
      } else {
        let copy = JSON.parse(JSON.stringify(this.$store.getters['Users/ACCOUNT_USER']))
        for (let el of copy) {
          let curAccount = el
          if (curAccount.active_block_id) {
            curAccount.active_block_name = 'Block'
            curAccount._cellVariants = {active_block_name: 'danger'}
          } else {
            curAccount.active_block_name = 'Active'
          }
          el.balance = Number.parseFloat(el.balance).toFixed(2)
          el.freezed_balance = Number.parseFloat(el.freezed_balance).toFixed(2)
          el._showDetails = false

          el.groupsStr = ''
          for (let elGroup of this.allAccInGroups) {
            if (elGroup.account_id === el.account_id) {
              el.groupsStr += el.groupsStr.length ? ',' : ''
              el.groupsStr += elGroup.group_name + '(' + elGroup.group_id + ')'
            }
          }
        }
        tmp = copy
      }
      this.$emit('input', tmp.length)
      return tmp
    },
    allAccInGroups () {
      return this.$store.getters['Users/ALL_ACCOUNTS_IN_GROUPS']
    }
  },
  mounted () {
    this.load()
    this.$store.dispatch('Users/GET_ALL_ACCOUNTS_IN_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/users/Accounts.vue